<template>
  <div class="sub-card wrapper-primery">
    <div class="card-content">
      <div class="header">
        <p>{{ name }}</p>
        <!-- <span> -20% </span> -->
      </div>

      <div class="prices" data-month="$9.99" data-year="$7.99">
        <template v-if="!isSystem">
          <p class="cost">${{ price }}</p>

          <span class="period"> /{{ $t("month") }} </span>
        </template>
        <p v-else class="cost">{{ $t("free") }}</p>
      </div>
      <!--
      <ul class="togle-period">
        <li class="period-item active">Месяц</li>

        <li class="period-item">Год</li>
      </ul> -->

      <ul class="profits">
        <li v-for="(advantages, index) in desc" :key="index" class="profit">
          {{ $te(`sub_chips.${advantages}`) ? $t(`sub_chips.${advantages}`) : advantages }}
        </li>
      </ul>
    </div>
    <!-- A-13: у системных статусов нет кнопок покупки -->
    <template v-if="!isSystem">
      <ConfirmEmail v-if="isNew && !emailVerified">
        <CustomButton
          class="choose-btn"
          type="сomplex"
          :class="{ 'is-loading': isLoading }"
        >
          {{ $t("try_free_sub", { days: subTryFree }) }}
        </CustomButton>
      </ConfirmEmail>
      <CustomButton
        v-else
        class="choose-btn"
        type="сomplex"
        :class="{ 'is-loading': isLoading, short: 1 }"
        @click="handleBuyClick"
      >
        {{
          isNew
            ? $t("try_free_sub", { days: subTryFree })
            : ` ${$t("Choose")} ${name}`
        }}
      </CustomButton>
      <!-- <CustomButton
        class="choose-btn"
        type="сomplex"
        :class="{ 'is-loading': isLoading, short: 1 }"
        @click="$emit('buy-coingate', _id)"
      >
        {{ $t("Choose") }} {{ name }} with coingate
      </CustomButton> -->
      <CustomButton
        v-if="isNowPaymentWork"
        class="choose-btn"
        type="сomplex"
        :class="{ 'is-loading': isLoading, short: 1 }"
        @click="$emit('buy-nowpayment', _id)"
      >
        {{ $t("Choose") }} {{ name }} with NowPayment
      </CustomButton>
    </template>
    <!-- <CustomButton class='choose-btn' v-else :disabled="disabled" @click="$emit('buy', _id)" :style="{ backgroundColor: color }"
    :class="{ 'is-loading': isLoading }">
      Choose {{ $t(name) }}
    </CustomButton> -->
  </div>
</template>

<script setup>
import { computed } from "vue";
import CustomButton from "../common/form/CustomButton.vue";
import ConfirmEmail from "../modal/ConfirmEmail.vue";
import { defineEmits } from "vue";

const props = defineProps({
  _id: String,
  subKey: String,
  subTryFree: Number,
  name: String,
  price: Number,
  days: Number,
  description: String,
  active: Number,
  purchases: Number,
  color: String,
  status: Boolean,
  isSystem: Boolean,
  disabled: Boolean,
  isLoading: Boolean,
  isNew: Boolean,
  isNowPaymentWork: Boolean,
  userSubscriptions: Array,
  emailVerified: Boolean,
});

const emit = defineEmits(["buy", "buy-coingate", "buy-nowpayment"]);

const handleBuyClick = (e) => {
  emit("buy", props._id);
};
const desc = computed(() =>
  (props.description || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean),
);
</script>

<style lang="scss" scoped>
$background-tab-card-active: #0b0b0b;
$border-color: #909da2;
$background-card: #f3f5f6;
$text-tab-card-active: #fff;
$background-tab-card: #1a1a1a;
$text-tab-card-passive: #757575;
$background-button-white: #fff;
$text-button-simple: #151515;
$font-size-card: 14px;

.sub-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 340px;

  .card-content {
    display: flex;
    width: 100%;
    flex-direction: column;

    .header {
      padding: 0 50px;
      width: 100%;
      line-height: 1.2;
      font-weight: 600;
      text-align: center;
      letter-spacing: -0.02em;
      color: #848484;
      font-size: 24px;
    }

    .prices {
      display: flex;
      justify-content: center;
      align-content: flex-end;
      align-items: flex-end;
      padding: 49px 0 0;
      line-height: 1.2;
      font-weight: 600;

      .cost {
        font-weight: 600;
        color: var(--font-color);
        font-size: 44px;
        margin: 0;
      }

      .period {
        padding: 0 0 5px;
        color: #848484;
      }
    }

    .togle-period {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      margin: 0 auto;
      padding: 4px;
      line-height: 1.2;
      font-weight: 600;
      border-radius: 100px;
      letter-spacing: -0.02em;
      color: $text-tab-card-passive;
      background: $background-tab-card;

      .active {
        pointer-events: none;
        color: $text-tab-card-active;
        background: $background-tab-card-active;
      }

      .period-item {
        cursor: pointer;
        padding: 6px 30px;
        border-radius: 100px;
        background: $background-tab-card;
        transition: 0.3s all;
      }
    }

    .profits {
      display: flex;
      flex-direction: column;
      gap: 7px 0;
      padding: 40px 0 0;
      margin: 0 auto;
      line-height: 1.2;
      letter-spacing: -0.02em;

      .profit {
        position: relative;
        padding: 0 0 0 25px;
        font-weight: 400;
      }

      .profit::before {
        pointer-events: none;
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 18px;
        height: 18px;
        background: url(../../assets/img/icon/checked-green.svg) center center
          no-repeat;
      }
    }
  }
}
</style>
